import getWithToken from '../base/get-with-token'

const queryReport = getWithToken('/report')

export default queryReport